/**
 * Parametri GSE in energia — D.M. 414/2023 e Regole Operative CACER (16 luglio
 * 2025). Solo quello che serve a dire quale energia è incentivabile e quale
 * eccedentaria: tariffe e importi in euro non fanno più parte del prodotto.
 */

/** Soglia di entrata in esercizio per accesso alla tariffa incentivante */
export const ELIGIBILITY_DATE = new Date('2021-12-16');

/**
 * Contributi in conto capitale oltre il 40% del costo non sono cumulabili con la
 * tariffa premio (RO Appendice B §3).
 */
export const MAX_CUMULATIVE_GRANT_PCT = 0.4;

/** Regola 70/30: quota massima capacità da impianti pre-esistenti */
export const MAX_PRE_EXISTING_RATIO = 0.3;

/**
 * Soglia di incentivabilità (Art. 8 § 3 D.M. 414/2023).
 * Quando l'energia condivisa supera questa quota della produzione annua, la quota
 * eccedentaria è destinata a consumatori non-impresa e/o finalità sociali sul territorio.
 *   55% per CER che accede solo alla tariffa premio (senza contributi c/c)
 *   45% per CER che cumula tariffa premio + contributo in conto capitale
 */
export const SOGLIA_INCENTIVABILITA_STANDARD = 0.55; // TIP senza contributi
export const SOGLIA_INCENTIVABILITA_PNRR = 0.45; // TIP + contributo c/c

/** Taglia massima impianto incentivabile (kW) */
export const MAX_PLANT_KW = 1000;

/**
 * Fasce orarie ARERA (TIAD 727/2022/R/eel) — quote % energia su base annua.
 *
 * Valori da profili statistici TERNA 2024 (distribuzione energia, non ore):
 *   F1 Punta       (Lun-Ven 8:00-19:00 esclusi festivi)              ≈ 43%
 *   F2 Intermedia  (Lun-Ven 7:00-8:00 e 19:00-23:00; Sab 7:00-23:00) ≈ 27%
 *   F3 Fuori Punta (0:00-7:00 e 23:00-24:00; Dom e festivi tutto il giorno) ≈ 30%
 *
 * Le quote 43/27/30 differiscono dalla quota-ore perché riflettono i profili
 * di produzione FV (concentrata in F1) e consumo effettivo TERNA 2024.
 */
export const TIME_BANDS = {
	F1: { label: 'Punta', share: 0.43, description: 'Lun-Ven 8:00-19:00 (esclusi festivi)' },
	F2: {
		label: 'Intermedia',
		share: 0.27,
		description: 'Lun-Ven 7:00-8:00 e 19:00-23:00; Sab 7:00-23:00',
	},
	F3: { label: 'Fuori Punta', share: 0.3, description: 'Notti, domeniche, festivi' },
} as const;
